export default __webpack_public_path__ + "static/media/Img0028.978be4ea.png";